var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"cpty_pill",class:[`cpty_pill_${_vm.slug}`, `cpty_pill_${_vm.size}`]},[(_vm.icon)?_c('span',{staticClass:"cpty_pill_icon",attrs:{"aria-hidden":"true"}},[_vm._v(_vm._s(_vm.icon))]):_vm._e(),_vm._v(" "+_vm._s(_vm.type)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }